<template>
	<div class="vh-100 bg-light" style="overflow:auto;">
		<div class="row gx-0">
            <div class="col-lg-6">
                <div class="row h-75 align-items-center justify-content-center">
                    <div class="col-xxl-6 col-8">
                        <div class="text-center col-6 m-auto p-3">
                            <img :src="logo" class="img-fluid" />
                        </div>
                        <form v-if="section == 'signin'" class="auth-signin-form" ref="formSignin" novalidate @submit.prevent="signin">
                            <div class="app--card card m-auto p-0">
                                <div class="card-body">
                                    <div v-if="!response.type" class="app--card-title">
                                        <span v-if="mfa == 0">Please sign in</span>
                                        <span v-if="mfa == 1">Please input the verification code sent to your mobile phone number</span>
                                        <span v-if="mfa == 2">Please input the code from the authenticator app</span>
                                    </div>
                                    <app--alert v-if="response.type" @dismiss="dismiss"
                                        :close="true"
                                        :description="response.description"
                                        :icon="response.icon"
                                        :title="response.title"
                                        :type="response.type"
                                    ></app--alert>
                                    <div v-if="mfa == 0" class="mb-3">
                                        <div class="input-group has-validation">
                                            <span class="input-group-text bg-white">
                                                <app--icon value="email" type="fas" class="fa-fw"></app--icon>
                                            </span>
                                            <input type="email" autocomplete="off" required autofocus
                                                class="form-control" 
                                                placeholder="Email address"
                                                v-model="email" />
                                            <div class="invalid-feedback"></div>
                                        </div>
                                    </div>
                                    <div v-if="mfa == 0" class="mb-3">
                                        <div class="input-group has-validation">
                                            <span class="input-group-text bg-white">
                                                <app--icon value="key" type="fas" class="fa-fw"></app--icon>
                                            </span>
                                            <input type="password" autocomplete="off" required
                                                class="form-control"
                                                placeholder="Password"
                                                v-model="password" />
                                            <div class="invalid-feedback"></div>
                                        </div>
                                    </div>
                                    <div v-if="mfa == 1 || mfa == 2" class="mb-3">
                                        <div class="input-group has-validation">
                                            <span class="input-group-text bg-white">
                                                <app--icon value="check" type="fas" class="fa-fw"></app--icon>
                                            </span>
                                            <input type="text" autocomplete="off" required ref="inputCode"
                                                class="form-control" 
                                                placeholder="Access code"
                                                v-model="code" />
                                            <div class="invalid-feedback"></div>
                                        </div>
                                    </div>
                                    <div class="d-grid mb-3">
                                        <app--button type="submit"
                                            class="btn btn-primary"
                                            label="Sign in"
                                            :loading="status.loading"
                                        ></app--button>
                                    </div>
                                    <a v-if="mfa != 1 && mfa != 2" href="javascript:void(0)" @click.prevent="toggle('forgot')" 
                                        class="link-secondary text-decoration-none">
                                        Forgot your password?
                                    </a>
                                </div>
                            </div>
                        </form>
                        <form v-if="section == 'forgot'" class="auth-forgot-form" ref="formReset" novalidate @submit.prevent="forgot">
                            <div class="app--card card m-auto p-0">
                                <div class="card-body">
                                    <div v-if="!response.type" class="app--card-title">
                                        <span>Please input your email address</span>
                                    </div>
                                    <app--alert v-if="response.type" @dismiss="dismiss"
                                        :close="true"
                                        :description="response.description"
                                        :icon="response.icon"
                                        :title="response.title"
                                        :type="response.type"
                                    ></app--alert>
                                    <div class="mb-3">
                                        <div class="input-group has-validation">
                                            <span class="input-group-text bg-white">
                                                <app--icon value="email" type="fas" class="fa-fw"></app--icon>
                                            </span>
                                            <input type="email" autocomplete="off" required autofocus
                                                class="form-control" 
                                                placeholder="Email address"
                                                v-model="email" />
                                            <div class="invalid-feedback"></div>
                                        </div>
                                    </div>
                                    <div class="d-grid mb-3">
                                        <app--button type="submit"
                                            class="btn btn-primary"
                                            label="Reset"
                                            :loading="status.loading"
                                        ></app--button>
                                    </div>
                                    <a href="javascript:void(0)" @click.prevent="toggle('signin')" 
                                        class="link-secondary text-decoration-none">
                                        Back to sign in
                                    </a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 d-none d-lg-block">
                <auth--splash />
            </div>
        </div>
	</div>
</template>

<script>
    import store from './store'
	export default {
        computed: {
            mfa()     { return store.state.mfa      },
            logo()    { return store.state.logo     },
            status()  { return store.state.status   },
            response(){ return this.status.response },
        },
        data() { 
            return { section: 'signin', email: null, password: null, code: null} 
        },
        watch: {
            mfa(value) { 
                if (value) { this.$nextTick(() => { this.$refs.inputCode.focus()}) } 
            }
        },
        methods: {
            signin(event) {
                this.$validate(event).then(() => {
                    const params = {email: this.email, password: this.password}
                    if (this.mfa == 1 || this.mfa == 2) {
                        params.code = this.code
                    }
                    if (this.$route.query && this.$route.query.SAMLRequest) {
                        params.SAMLRequest = this.$route.query.SAMLRequest
                        if (this.$route.query.RelayState) {
                            params.RelayState = this.$route.query.RelayState
                        }
                    }
                    store.dispatch('signin', params).then(response => { 
                        if (response && response.SAMLResponse && response.SAMLDestination) {
                            this.saml(response)
                        } else if (response) {
                            document.location = response
                        } else {
                            if (this.mfa == 0) {
                                this.password = null 
                            }
                            this.code = null
                        }
                    })
                })
            },
            forgot(event) {
                this.$validate(event).then(() => {
                    store.dispatch('forgot', {email: this.email})
                })
            },
            toggle(section) {
                if (section == 'signin' && this.$refs.formSignin) {
                    this.$validationReset(this.$refs.formSignin)
                } 
                if (section == 'forgot' && this.$refs.formForgot) {
                    this.$validationReset(this.$refs.formForgot)
                } 
                this.email = this.password = this.code = null
                store.commit('REQUEST', {loading: false})
                this.section = section
            },
            dismiss() {
                store.commit('REQUEST', {loading: false})
            },
            saml(response) {
                let form = document.createElement("form")
                    form.method = "POST"
                    form.action = response.SAMLDestination
                
                let SAMLResponse = document.createElement("input")
                    SAMLResponse.value = response.SAMLResponse
                    SAMLResponse.name = 'SAMLResponse'
                    SAMLResponse.type = 'hidden' 

                form.appendChild(SAMLResponse)
                if (response.SAMLRelayState) {
                    let RelayState = document.createElement("input") 
                        RelayState.value = response.SAMLRelayState
                        RelayState.name = 'RelayState'
                        RelayState.type = 'hidden' 

                    form.appendChild(RelayState)
                }
                document.body.appendChild(form)
                form.submit()
            }
        }
	}
</script>
